type Props = {
  className?: string
  isSelected: boolean
}

export function RadioCheckedIcon({ className, isSelected }: Props) {
  const baseClass = `mt-0.5 inline-block size-[19px] min-w-[19px] min-h-[19px] rounded-full border-solid border-2 shrink-0 ${
    className ?? ''
  }`

  return (
    <span
      className={
        isSelected
          ? `${baseClass} border-restructure-background-action-1 text-restructure-background-action-1`
          : `${baseClass} border-neutral-400`
      }
      style={
        isSelected
          ? {
              backgroundImage:
                'radial-gradient(circle, #3643ba 0 4px, transparent 4px)',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
          : undefined
      }
    />
  )
}
